import './addStock.css'
import {useState,useEffect} from 'react'
import {EditBillDetailModal} from './utils/EditBillDetailModal'
import {BillDetailsFields} from './utils/billDetailsFields'

const BillDetails = (props: any) => {


  const [fieldStates, setFieldState] = useState<BillDetailsFields>({
    totalAmount: props.billDetails.totalAmount,
    cashDiscount: props.billDetails.cashDiscount,
    discountAmount: props.billDetails.discountAmount,
    sgstPayable: props.billDetails.sgstPayable,
    cgstPayable: props.billDetails.cgstPayable,
    netAmount: props.billDetails.netAmount,
    totalUnits: props.billDetails.totalUnits,
  })

  const [isShowEditModal, setShowEditModal] = useState(false)

  useEffect(() => {
    if (props.billDetails) {
      setFieldState({
        totalAmount: props.billDetails.totalAmount,
        cashDiscount: props.billDetails.cashDiscount,
        discountAmount: props.billDetails.discountAmount,
        sgstPayable: props.billDetails.sgstPayable,
        cgstPayable: props.billDetails.cgstPayable,
        netAmount: props.billDetails.netAmount,
        totalUnits: props.billDetails.totalUnits,
      })
    }
  }, [props.billDetails])


  const onUpdateField = (updatedValues: BillDetailsFields) => {
    setFieldState((prevState) => ({
      ...prevState,
      ...updatedValues,

      netAmount:
        updatedValues.totalAmount -
        Number(updatedValues.cashDiscount) -
        Number(updatedValues.discountAmount) +
        Number(updatedValues.sgstPayable) +
        Number(updatedValues.cgstPayable),
    }))
  }

  return (
    <div className='bill-container'>
      {isShowEditModal && (
        <EditBillDetailModal
          billDetails={fieldStates}
          modalState={isShowEditModal}
          closeModal={() => {
            setShowEditModal(false)
          }}
          onUpdateField={onUpdateField}
        />
      )}
      <div className='d-flex justify-content-between'>
        <div className='bill-text'>Bill Details</div>
        <button
          className='ePulse-button'
          onClick={() => {
            setShowEditModal(true)
          }}
        >
          Edit
        </button>
      </div>

      <div className='d-flex justify-content-between'>
        <div className='amt'>Total Amount</div>
        <div>{fieldStates.totalAmount.toFixed(2)}</div>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='amt'>Cash Discount</div>
        <div>{fieldStates.cashDiscount.toFixed(2)}</div>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='amt'>Discount Amount</div>
        <div>{fieldStates.discountAmount.toFixed(2)}</div>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='amt'>SGST PAYABLE</div>
        <div>{fieldStates.sgstPayable.toFixed(2)}</div>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='amt'>CGST PAYABLE</div>
        <div>{fieldStates.cgstPayable.toFixed(2)}</div>
      </div>
      <div className='d-flex justify-content-between'>
        <div className='bill-text'>Net Invoice Amount :</div>
        <div className='bill-text'>{fieldStates.netAmount.toFixed(2)}</div>
      </div>

      <div className='d-flex justify-content-between'>
        <button
          className='ePulse-button'
          onClick={() => {
            props.handleApiCall()
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  )
}

export default BillDetails
